import React from "react";

import { Input } from "antd";

import searchIcon from "../../../../../assets/images/product/specmanager/search-line.svg";
import "../../../Product.css";
import "./SpecManagerSearch.css";

class SpecManagerSearch extends React.Component {
  constructor(props) {
    super(props);
    const { searchValue } = this.props;
    this.state = {
      searchValue: "" || searchValue,
    };
  }

  handleSearchChange = async (e, buttonClicked) => {
    const { searchValue } = this.state;
    const { handleSearchChange, searchField } = this.props;
    let value = "";
    if (!buttonClicked) {
      value = e.target.value;
    } else {
      value = searchValue;
    }
    this.setState({
      searchValue: value.trim() === "" ? "" : value,
    });
    if ((buttonClicked || e.key === "Enter" || value === "")) {
      await handleSearchChange(value, searchField);
    }
  }

  render() {
    const { flag, updateShowFilters, placeholder = "Search" } = this.props;
    const { searchValue } = this.state;
    let formControlId = "reportSearchInput";
    if (flag === "templates") {
      formControlId = "reportSearchInput2";
    } else if (flag === "analytics") {
      formControlId = "reportSearchInput3";
    }

    return (
      <div
        className="EnvSpecManagerSearchContainer"
        style={{ height: flag === "reports" || flag === "reports_spec" ? "40px" : "80px" }}
      >
        <div className={flag === "analytics" ? "searchFormAnalytics" : "searchForm"}>
          <div className="searchBar EnvSpecManagerSearchContainer__MainSection" id="specManagerSearchContainer"/* style={{ position: "relative" }} */>
            <Input
              id={formControlId}
              className="specManagerSearchInput"
              placeholder={placeholder}
              onChange={(event) => {
                this.handleSearchChange(event, false);
              }}
              value={searchValue}
              onPressEnter={(event) => {
                event.preventDefault();
                this.handleSearchChange(event, false);
              }}
              onFocus={() => updateShowFilters(true)}
            />
            <div
              className="ProdSpecManagerSearchBtn"
              onClick={(event) => {
                this.handleSearchChange(event, true);
              }}
            >
              <img
                className="specManagerSearchWhiteMagnifyIcon"
                src={searchIcon}
                alt="search icon"
              />

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SpecManagerSearch;
